import getStore from '../store/store';
import SchedulingPolicy from 'owa-service/lib/contract/SchedulingPolicy';

/**
 * Util to get default scheduling policy from store.
 */
export default function getDefaultSchedulingPolicy(): SchedulingPolicy {
    let store = getStore();
    let settings = store.publishingSettings;
    return (settings && settings.DefaultSchedulingPolicy) || null;
}
